import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';

interface CompatibilityItem {
    category: string;
    image: string;
    products: string[];
    compatible: boolean;
    outlets: string;
    accessories: string[];
}

export function getCompatibilityData() {
    const { t } = useLang('CompatibilityTable');
    // 兼容性数据配置
    const compatibilityData: CompatibilityItem[] = [
        {
            category: t('battery_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361835220-m0q1un-compressed-1.png',
            products: [t('battery_product_1'), t('battery_product_2')],
            compatible: true,
            outlets: t('battery_outlets_1'),
            accessories: [t('battery_accessories_1')],
        },
        {
            category: t('battery_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361844038-14gpcc-compressed-2.png',
            products: [t('battery_product_3'), t('battery_product_4')],
            compatible: true,
            outlets: t('battery_outlets_2'),
            accessories: [t('battery_accessories_2'), t('battery_accessories_3')],
        },
        {
            category: t('alternater_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763365868473-jxq469-compressed-3.png',
            products: [t('alternater_product_1'), t('alternater_product_2')],
            compatible: true,
            outlets: t('alternater_outlets_1'),
            accessories: [t('alternater_accessories_1')],
        },
        {
            category: t('alternater_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763365857851-0d55ez-compressed-4.png',
            products: [t('alternater_product_3'), t('alternater_product_4')],
            compatible: true,
            outlets: t('alternater_outlets_2'),
            accessories: [t('alternater_accessories_2'), t('alternater_accessories_3')],
        },
        {
            category: t('generator_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361881798-2l2vbz-compressed-5.png',
            products: [t('generator_product_1')],
            compatible: true,
            outlets: t('generator_outlets_1'),
            accessories: [t('generator_accessories_1')],
        },
        {
            category: t('generator_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361905118-bsmxbd-compressed-6.png',
            products: [t('generator_product_2')],
            compatible: true,
            outlets: t('generator_outlets_2'),
            accessories: [t('generator_accessories_2'), t('generator_accessories_3')],
        },
        {
            category: t('panel_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361914638-9n383u-compressed-11.png',
            products: [t('panel_product_1'), t('panel_product_2')],
            compatible: true,
            outlets: t('panel_outlets_1'),
            accessories: [t('panel_accessories_1')],
        },
        {
            category: t('panel_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361925725-ymkpmy-compressed-10.png',
            products: [t('panel_product_3'), t('panel_product_4')],
            compatible: true,
            outlets: t('panel_outlets_2'),
            accessories: [t('panel_accessories_2')],
        },
        {
            category: t('outdoor_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361933909-7ws2xe-compressed-9.png',
            products: [t('outdoor_product_1'), t('outdoor_product_2')],
            compatible: true,
            outlets: t('outdoor_outlets_1'),
            accessories: [t('outdoor_accessories_1')],
        },
        {
            category: t('outdoor_title'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361942760-m857h8-compressed-8.png',
            products: [t('outdoor_product_3'), t('outdoor_product_4')],
            compatible: true,
            outlets: t('outdoor_outlets_2'),
            accessories: [t('outdoor_accessories_2')],
        },
    ];

    const tableRows = [
        {
            header: t('product_information'),
            renderCell: (item: CompatibilityItem) => (
                <>
                    <div className="header-wrapper">
                        <EcoImg pc={item.image} />
                        <div className="category-name">{item.category}</div>
                        <div className="products">
                            <div className="product-item">
                                {item.products.map((product, index) => (
                                    <div key={index} className="product-name">
                                        {product}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            ),
        },
        {
            header: t('compatibility'),
            renderCell: (item: CompatibilityItem) => (item.compatible ? <span style={{ fontSize: '17px' }}>✅</span> : null),
        },
        {
            header: t('delta_3_max_plus_outlets'),
            renderCell: (item: CompatibilityItem) => item.outlets,
        },
        {
            header: t('ecoflow_connection_accessories'),
            renderCell: (item: CompatibilityItem) => (
                <>
                    {item.accessories.map((accessory, index) => (
                        <div key={index} className="accessoryItem">
                            {accessory}
                        </div>
                    ))}
                </>
            ),
        },
    ];

    const mobileTableData = {
        products: [
            {
                title: t('battery_title'),
                span: 2,
                items: [
                    {
                        names: [
                            {
                                title: t('battery_product_1'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361557207-cgkfnm-compressed-sl_delta%203%20series/d3mp.png',
                            },
                            {
                                title: t('battery_product_2'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361576685-kxuoi3-compressed-Frame%201000008024.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('battery_outlets_1'),
                        accessories: [t('battery_accessories_1')],
                    },
                    {
                        names: [
                            {
                                title: t('battery_product_3') + '\n\n',
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361612167-72n4z6-compressed-sl_dseb.png',
                            },
                            {
                                title: t('battery_product_4'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361620780-9ngzgf-compressed-sl_dseb.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('battery_outlets_2'),
                        accessories: [t('battery_accessories_2'), t('battery_accessories_3')],
                    },
                ],
            },
            {
                title: t('alternater_title'),
                span: 2,
                items: [
                    {
                        names: [
                            {
                                title: t('alternater_product_1'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361630418-iemoyd-compressed-sl_alternator%20charger/500W%20_New.png',
                            },
                            {
                                title: t('alternater_product_2'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361641970-rlinle-compressed-sl_alternator%20charger/600W.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('alternater_outlets_1'),
                        accessories: [t('alternater_accessories_1')],
                    },
                    {
                        names: [
                            {
                                title: t('alternater_product_3'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361650696-74aece-compressed-sl_alternator%20charger/800W.png',
                            },
                            {
                                title: t('alternater_product_4'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361658260-6m2c0p-compressed-sl_alternator%20charger/1000W.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('alternater_outlets_2'),
                        accessories: [t('alternater_accessories_2'), t('alternater_accessories_3')],
                    },
                ],
            },
            {
                title: t('generator_title'),
                span: 2,
                items: [
                    {
                        names: [
                            {
                                title: t('generator_product_1'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361669348-4ljll5-compressed-sl_sg.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('generator_outlets_1'),
                        accessories: [t('generator_accessories_1')],
                    },
                    {
                        names: [
                            {
                                title: t('generator_product_2'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361676368-writy5-compressed-sl_sg.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('generator_outlets_2'),
                        accessories: [t('generator_accessories_2'), t('generator_accessories_3')],
                    },
                ],
            },
            {
                title: t('panel_title'),
                span: 2,
                items: [
                    {
                        names: [
                            {
                                title: t('panel_product_1'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361687361-aiqw52-compressed-sl_sp.png',
                            },
                            {
                                title: t('panel_product_2'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361695864-2kzwnc-compressed-sl_sp.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('panel_outlets_1'),
                        accessories: [t('panel_accessories_1')],
                    },
                    {
                        names: [
                            {
                                title: t('panel_product_3'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361702922-ohcq18-compressed-sl_sp.png',
                            },
                            {
                                title: t('panel_product_4'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361711416-1xb6ue-compressed-sl_sp.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('panel_outlets_2'),
                        accessories: [t('panel_accessories_2')],
                    },
                ],
            },
            {
                title: t('outdoor_title'),
                span: 2,
                items: [
                    {
                        names: [
                            {
                                title: t('outdoor_product_1'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361719596-sa0uvl-compressed-sl_w2.png',
                            },
                            {
                                title: t('outdoor_product_2'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361744997-5xtfln-compressed-sl_w3.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('outdoor_outlets_1'),
                        accessories: [t('outdoor_accessories_1')],
                    },
                    {
                        names: [
                            {
                                title: t('outdoor_product_3'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361753079-cmzk9m-compressed-sl_g.png',
                            },
                            {
                                title: t('outdoor_product_4'),
                                image: 'https://websiteoss.ecoflow.com/figma-uploads/1763361761372-7ewotd-compressed-sl_g2.png',
                            },
                        ],
                        compatible: true,
                        outlets: t('outdoor_outlets_2'),
                        accessories: [t('outdoor_accessories_2')],
                    },
                ],
            },
        ],
    };
    return {
        compatibilityData,
        tableRows,
        mobileTableData,

        alsoLike: {
            us: {
                variantId: '39704596152393',
                buy_link: 'https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?_pos=1&_sid=dbe27b739&_ss=r',
            },
            ca: {
                variantId: '41770346315930',
                buy_link: 'https://ca.ecoflow.com/products/delta-pro-to-smart-generator-adapter?_pos=1&_sid=dbe27b739&_ss=r&variant=39704596152393',
            },
        },
    };
}
